import { useEffect } from 'react'
import { Alert, RadioGroup, RadioGroupItem, Text } from '@/ui'
import { useAnalyticsView } from '@/features/amplitude'
import { TypographyStyles } from '@/styles'
interface ILBAIntroPageProps {
  isInterestedInLba: boolean | null | undefined
  setIsInterestedInLba: (isInterestedInLba: boolean) => void
}

export const LBAIntroPage = ({
  isInterestedInLba,
  setIsInterestedInLba,
}: ILBAIntroPageProps) => {
  const pageView = useAnalyticsView()

  useEffect(() => {
    pageView('lba interest')
  }, [pageView])

  return (
    <div className="space-y-6">
      <Text variant={TypographyStyles.H2}>
        Don&apos;t want to upload bank statements every month?
      </Text>

      <Text className="max-w-2xl">
        At least one of your banks allows <b>limited bank access</b>, which
        grants Heard a separate login to your accounts, allowing us to download
        your bank statements directly. Moving forward, you wouldn&apos;t have to
        upload them each month.
      </Text>

      <div className="space-y-3">
        <Text variant={TypographyStyles.H3}>Are you interested?</Text>
        <RadioGroup>
          <RadioGroupItem
            value="yes"
            checked={isInterestedInLba === true}
            onChange={() => setIsInterestedInLba(true)}
          />
          <RadioGroupItem
            value="no"
            checked={isInterestedInLba === false}
            onChange={() => setIsInterestedInLba(false)}
          />
        </RadioGroup>
      </div>

      {isInterestedInLba === false && (
        <div className="max-w-2xl bg-stone p-4 rounded">
          <Alert
            variant="default"
            description="No problem. You can always reach out to us if you would like to
            set up limited bank access in the future."
          />
        </div>
      )}
    </div>
  )
}
